import React, { useEffect, useState } from 'react';

import GeneralRiskDefinitionsTableEditRow from './GeneralRiskDefinitionsTableEditRow';
import GeneralRiskDefinitionsTableRow from './GeneralRiskDefinitionsTableRow';

import Toast from 'CommonComponents/Toast';

export default function GeneralRiskDefinitionsTable(props) {
    const [definitions, setDefinitions] = useState([]);
    const [editableDefinition, setEditableDefinition] = useState(null);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        fetchGeneralRiskDefinitions();
    }, []);

    const fetchGeneralRiskDefinitions = () => {
        setIsLoading(true);
        axios
            .get(props.fetchUrl)
            .then(({ data }) => {
                setDefinitions([...data]);
            })
            .catch((e) => {
                console.error(e);
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    const prepareUpdateUrl = (definition) => {
        return props.updateUrl.replace('DEFINITION_ID', definition.id);
    };

    return (
        <div className="inbud-table_wrapper">
            <table className="inbud-table">
                <thead>
                    <tr>
                        <th className="tw-w-44">{$t('Category')}</th>
                        <th>{$t('Description')}</th>
                        <th className="tw-w-40">{$t('Actions')}</th>
                    </tr>
                </thead>
                <tbody>
                    {!isLoading &&
                        !!definitions?.length &&
                        definitions.map((definition) => {
                            if (editableDefinition && parseInt(editableDefinition.id) === parseInt(definition.id)) {
                                return (
                                    <GeneralRiskDefinitionsTableEditRow
                                        key={definition.id}
                                        definition={definition}
                                        onUpdated={fetchGeneralRiskDefinitions}
                                        updateUrl={prepareUpdateUrl(definition)}
                                        onCancel={() => setEditableDefinition(null)}
                                        onEdit={() => setEditableDefinition(definition)}
                                    />
                                );
                            } else {
                                return (
                                    <GeneralRiskDefinitionsTableRow
                                        key={definition.id}
                                        definition={definition}
                                        onEdit={() => setEditableDefinition(definition)}
                                        onCategoryClick={props.onCategoryClick}
                                    />
                                );
                            }
                        })}
                    {isLoading && (
                        <tr>
                            <td colSpan="100">{$t('Loading')}...</td>
                        </tr>
                    )}
                    {!isLoading && !definitions?.length && (
                        <tr>
                            <td colSpan="100">
                                <span>{$t('No Definitions found')}</span>
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>

            <Toast id="general-risk-definition-update-toast" message="general risk definition updated successfully" />
            <Toast id="general-risk-definition-update-failed-toast" message="general risk definition update failed" />
        </div>
    );
}
